import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for route navigation
import cyberImage from "../../assests/tech/imagepartical.jpg"; 

const IndiaAbout = () => {
  const navigate = useNavigate(); // Initialize the navigate function

  const handleJoinClick = () => {
    navigate("/CourseEnroll"); // Navigate to the CourseEnroll page
  };

  return (
    <div className="indaAboutContainer">
      {/* Hero Section */}
      <section className="indaHeroSection">
        <div className="indaHeroText">
          <h1>Protecting Tomorrow’s Digital World, Today!</h1>
          <p>
            SecurTech Indore is a leading cybersecurity institute, equipping
            students with practical, industry-ready skills to tackle modern
            digital threats.
          </p>
          <button className="indaCtaButton" onClick={handleJoinClick}>
            Join Us Now
          </button>
        </div>
        <div className="indaHeroImage">
          <img src={cyberImage} alt="Cybersecurity" />
        </div>
      </section>

      {/* Mission Section */}
      <section className="indaMissionSection">
        <h2>Our Mission</h2>
        <p>
          To bridge the gap between theory and practice by empowering learners
          with hands-on training in ethical hacking, network security, cyber
          defense, and risk management.
        </p>
      </section>

      {/* Features Section */}
      <section className="indaFeaturesSection">
        <h2>What We Offer</h2>
        <div className="indaFeaturesGrid">
          <div className="indaFeatureCard">
            <h3>Practical Training</h3>
            <p>Real-world labs and simulations for industry-ready skills.</p>
          </div>
          <div className="indaFeatureCard">
            <h3>Certified Courses</h3>
            <p>CEH, CompTIA Security+, CCNA, and more certifications.</p>
          </div>
          <div className="indaFeatureCard">
            <h3>Expert Guidance</h3>
            <p>Learn from certified trainers with years of IT experience.</p>
          </div>
          <div className="indaFeatureCard">
            <h3>Career Support</h3>
            <p>Internships, projects, and placement assistance for every student.</p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="indaCtaSection">
        <h2>Become a Cyber Defender of Tomorrow</h2>
        <p>Secure your future in the fast-growing world of cybersecurity.</p>
        <button className="indaCtaButton" onClick={handleJoinClick}>
          Enroll Today
        </button>
      </section>
    </div>
  );
};

export default IndiaAbout;
